import React, { Component } from "react";

const SearchIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.502 11.0002H11.708L11.432 10.7262C12.407 9.58921 13 8.11521 13 6.50021C13 2.91021 10.09 0.000211716 6.5 0.000211716C2.91 0.000211716 0 2.91021 0 6.50021C0 10.0902 2.91 13.0002 6.5 13.0002C8.115 13.0002 9.588 12.4082 10.725 11.4342L11.001 11.7082V12.5002L15.999 17.4912L17.49 16.0002L12.502 11.0002ZM6.5 11.0002C4.014 11.0002 2 8.98624 2 6.50024C2 4.01524 4.014 2.00024 6.5 2.00024C8.985 2.00024 11 4.01524 11 6.50024C11 8.98624 8.985 11.0002 6.5 11.0002Z"
        fill={fill}
      />
    </svg>
  );
};

SearchIcon.defaultProps = {
  width: 18,
  height: 18,
  fill: "white",
};

export default SearchIcon;
